export default __webpack_public_path__ + "static/media/la-solid-900.a8130346.svg";